

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const SUGGESTCONNECTIONS= createAsyncThunk(
  "suggestConnections/suggestConnections",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const suggestConnectionsSlice = createSlice({
  name: "suggestConnectionsSlice",
  initialState: {
    suggestConnections: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfsuggestConnections: (state) => {
        state.suggestConnections.loading = false
        state.suggestConnections.error = false
        state.suggestConnections.data = []
        state.suggestConnections.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(SUGGESTCONNECTIONS.fulfilled, (state, action) => {
      state.suggestConnections = {
        ...state.suggestConnections,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SUGGESTCONNECTIONS.pending, (state, action) => {
      state.suggestConnections = {
        ...state.suggestConnections,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SUGGESTCONNECTIONS.rejected, (state, action) => {
      state.suggestConnections = {
        ...state.suggestConnections,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const suggestConnectionsAction = {
    SUGGESTCONNECTIONS,
};

export { suggestConnectionsAction };
export default suggestConnectionsSlice.reducer;
export const {setInitialStateOfsuggestConnections} = suggestConnectionsSlice.actions